<template>
  <el-container class="main_container">
    <el-aside :class="isCollapse ? 'width64' : 'width220'">
      <template>
        <div class="div">
          <div class="survey_logo">
            <p v-if="isCollapse == false">
              <img src="https://download.hecoos.com/enlightv/2024-33/QSSSwTwjzRjCxjwehTiy.png" alt="" height="34">
              <span>澜景在线授权管理后台</span>
            </p>
          </div>
          <el-menu :default-active="defaultActive" :unique-opened="true" router :collapse="isCollapse">
            <template v-for="item in menuList">
              <el-menu-item :index="item.path" :key="item.id" v-if="!item.hasOwnProperty('child')">
                <i :class="item.icon"></i> <span slot="title" class="blod">{{ item.name }}</span>
              </el-menu-item>
              <el-submenu :index="item.id" :key="item.id" v-if="item.hasOwnProperty('child')">
                <template slot="title">{{ item.name }}</template>
                <template v-for="sub in item.child">
                  <el-menu-item :index="sub.path" :key="sub.id" v-if="!sub.hasOwnProperty('child')">
                    {{ sub.name }}
                  </el-menu-item>
                </template>
              </el-submenu>
            </template>
          </el-menu>
        </div>
      </template>
    </el-aside>
    <el-container>
      <el-header>
        <template>
          <div class="paas_header">
            <div class="menu_btn">
              <!--              <span @click="toggleNav()" :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></span>-->
            </div>
            <div class="project_name"></div>
            <div class="info_wrap">
              <el-dropdown>
                <div class="user_info">
                  <img :src="userInfoDetail.avatar ? userInfoDetail.avatar :'https://download.hecoos.com/enlightv/2024-33/HZHxfRWpzAKjx5Crb3AM.jpg'" alt="">
                  <span class="user_name" v-text="userInfoDetail.name"></span>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item  @click.native="handleClickEdit()">修改个人信息</el-dropdown-item>
                  <el-dropdown-item  @click.native="handleClickEditPassword()">修改密码</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <span class="exit_btn" @click="out_login">退出</span>

            </div>
          </div>
        </template>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
    <adminEditPersonal :editPersonalVisible.sync="editPersonalVisible" v-if="editPersonalVisible"  @success="editPersonalSuccess()"/>
    <adminEditPassword :editPasswordVisible.sync="editPasswordVisible" v-if="editPasswordVisible"  @success="editPasswordSuccess()"/>
  </el-container>
</template>
<script>

import { mapState } from 'vuex'
import {adminPersonalDetail} from "@/api/api";
import adminEditPersonal from './components/admin_edit_personal.vue'
import adminEditPassword from './components/admin_edit_password.vue'
export default {
  name: "layout",
  components: {
    adminEditPersonal,
    adminEditPassword
  },
  computed: {
    ...mapState(['adminUserInfo']),
  },
  data() {
    return {
      userInfoDetail:{
        avatar:'',
        name:'',
      },
      isCollapse: false,
      menuList: [
        {
          id: '001',
          name: '用户管理',
          path:'/admin/individual_users',
          child:[
            {
              id:'011',
              name:'用户列表',
              path:'/admin/individual_users'
            },
            {
              id:'012',
              name:'公司管理',
              path:'/admin/enterprise_users'
            },
            {
              id:'013',
              name:'授权管理',
              path:'/admin/auth_manage'
            },
          ]
        },
        {
          id: '002',
          name: '订单管理',
          path:'/admin/order',
        },
        {
          id: '003',
          name: '产品管理',
          path:'/admin/product',
        },
      ],
      defaultActive: '',
      editPersonalVisible:false,
      editPasswordVisible:false,
    }
  },
  created() {
    this.getUserDetail()
    this.defaultActive = this.$route.path
    if(this.$route.name == 'user_detail'){
      this.defaultActive = '/admin/individual_users'
    }else{
      this.defaultActive = this.$route.path
    }
    if(!this.adminUserInfo || !this.adminUserInfo.id){
      localStorage.clear()
      this.$router.replace({name:'adminLogin'});
    }
  },
  watch: {
    '$route.name': function (newVal, oldVal) {
      if (newVal) {
        this.defaultActive = this.$route.path
        // if(newVal == 'user_detail'){
        //   this.defaultActive = '/admin/individual_users'
        // }else{
        //   this.defaultActive = this.$route.path
        // }
      }
    }
  },
  mounted() {

  },
  methods: {
    // 获取用户信息
    getUserDetail () {
      adminPersonalDetail().then(res => {
        if (res.code === 200) {
          const { data } = res
          this.userInfoDetail.avatar = data.avatar
          this.userInfoDetail.name = data.name
        }
        this.loading = false
      })
    },
    editPersonalSuccess(){
      this.getUserDetail()
    },

    editPasswordSuccess(){
      this.$store.dispatch('clearAdminUserInfo')
      this.$router.replace({name:'adminLogin'});
    },

    handleClickEdit(){
      this.editPersonalVisible = true
    },
    handleClickEditPassword(){
      this.editPasswordVisible = true
    },

    toggleNav() {
      this.isCollapse = !this.isCollapse
    },

    // 退出登录
    out_login(){
      this.$confirm('确定退出登录吗？', '提示', {
        type: 'error',
        closeOnClickModal: false,
        closeOnPressEscape: false,
      }).then(() => {
        // localStorage.removeItem('vuex')
        this.$store.dispatch('clearAdminUserInfo')
        this.$router.replace({name:'adminLogin'});
      }).catch(() => {

      })
    },


  }
};
</script>
<style lang="scss" scoped>
.main_container {
  .el-header {
    background: #fff;
    padding: 0;
  }

  .el-aside {
    // height: calc(100vh - 60px);
    height:100vh;

    background-color: #fff;
    color: #333;
    text-align: center;
    line-height: 200px;
  }

  .el-main {
    height: calc(100vh - 60px);
    background-color: #e9eef3;
    padding: 0;
  }
}

.width64 {
  width: 64px !important
}

.width220 {
  width: 220px !important
}

.survey_logo {
  border-bottom: 1px solid #f1f1f1;
  text-align: center;
}


.survey_logo p {
  margin-top: 0px;
  display: block;
  padding:0 10px;
  font-size: 14px;
  line-height: 59px;
  letter-spacing: 2px;
  font-weight: 700;
  text-align: left;
  margin-bottom: 0;
}
.survey_logo  p img{
  vertical-align: middle;
  margin-right: 5px;
}

::v-deep .el-menu {
  background: none !important;
  text-align: left;
  .el-submenu__title{
    //color: rgba(25, 144, 255, 1);
  }
  .el-menu-item {
    height: 40px;
    line-height: 40px;
    &.is-active {
      background: rgba(25, 144, 255, 0.08);
      color: rgba(25, 144, 255, 1);
      position: relative;
      &:after{
        width: 2px;
        height: 40px;
        content: ' ';
        background:rgba(25, 144, 255, 1);
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }
}

.paas_header {
  height: 60px;
  display: flex;
  box-shadow: 0 1px 0 0 hsla(0, 0%, 93.3%, .5);
  border-bottom: 1px solid #f1f1f1;

  .menu_btn {
    display: inline-flex;
    width: 60px;
    height: 60px;
    align-items: center;
    justify-content: center;

    span {
      color: #333;
      font-size: 30px;
      cursor: pointer;
    }
  }
  .info_wrap {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .user_info{
      display: flex;
      align-items: center;
      margin-right: 8px;
      cursor: pointer;
      img{
        width: 24px;
        height: 24px;
        margin-right: 8px;
        border-radius: 50%;
      }
      .user_name {
        font-size: 18px;
        color: rgba(51, 51, 51, 1);
        line-height: 28px;
      }
    }
    .template_color{
      font-size: 18px;
      line-height: 28px;
      cursor: pointer;
    }
    .exit_btn{
      margin: 0 35px 0 8px;
      font-size: 18px;
      color: rgba(240, 41, 41, 1);
      line-height: 28px;
      cursor: pointer;
    }

  }
}
</style>
